import { render, staticRenderFns } from "./synergy.vue?vue&type=template&id=64e71aaa&scoped=true"
import script from "./synergy.vue?vue&type=script&lang=js"
export * from "./synergy.vue?vue&type=script&lang=js"
import style0 from "./synergy.vue?vue&type=style&index=0&id=64e71aaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e71aaa",
  null
  
)

export default component.exports